import { useTheme } from "styled-components";
import { StyledFlexColumn, StyledFlexRow } from "../../../styles/LayoutStyles";
import InputWrapper from "../../../components/input/wrapper/InputWrapper";
import { useLanguageContext } from "../../../context/LanguageContext";
import EVAApiHelper from "../../../helpers/EVAApiHelper";
import { StyledInput } from "../../../styles/InputStyles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

export default function PasswordResetInput({
  data,
  setData,
  submitError,
  style,
}) {
  const { translate } = useLanguageContext();
  const theme = useTheme();

  const passwordInfo = [
    { key: "length", validation: data.password.length >= 12 },
    { key: "uppercase", validation: /[A-Z]/.test(data.password) },
    { key: "lowercase", validation: /[a-z]/.test(data.password) },
    { key: "number", validation: /\d/.test(data.password) },
    {
      key: "special_character",
      validation: /[^\w\s]/.test(data.password),
    },
  ];

  return (
    <StyledFlexColumn style={{ gap: theme.spacing.large, ...style }}>
      <div>
        <InputWrapper
          for="password"
          label={translate("eva.main.validation.attributes.password")}
          required
          error={EVAApiHelper.getResponseError("password", submitError)}
          style={{ marginBottom: theme.spacing.small }}
        >
          <StyledInput
            type="password"
            id="password"
            name="password"
            value={data.password}
            onChange={(e) => setData({ ...data, password: e.target.value })}
            placeholder={translate("eva.main.validation.placeholders.password")}
          />
        </InputWrapper>

        {passwordInfo.map((info) => (
          <StyledFlexRow
            key={info.key}
            style={{
              opacity: info.validation ? 1 : 0.33,
              alignItems: "center",
              flexWrap: "nowrap",
            }}
          >
            <FontAwesomeIcon
              icon={info.validation ? faCheck : faXmark}
              style={{ width: "30px" }}
            />

            <p>
              {translate(
                `eva.main.auth.password_reset.confirm.password_info.${info.key}`,
              )}
            </p>
          </StyledFlexRow>
        ))}
      </div>

      <InputWrapper
        for="password_confirmation"
        label={
          translate("eva.main.validation.attributes.password") +
          " (" +
          translate("eva.main.general.confirm") +
          ")"
        }
        required
      >
        <StyledInput
          type="password"
          id="password_confirmation"
          name="password_confirmation"
          value={data.password_confirmation}
          onChange={(e) =>
            setData({ ...data, password_confirmation: e.target.value })
          }
          placeholder={translate("eva.main.validation.placeholders.password")}
        />
      </InputWrapper>
    </StyledFlexColumn>
  );
}
